import { RenderedAsset, } from "../../../model/assets/SDKRenderedAsset";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Request engine: Render
export class DataCoreRenderRequests {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(bridge) {
        this.bridge = bridge;
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Rendering
    async renderAssetsForConfiguration(designSystemId, versionId, settings, assets, groups) {
        // Configure payload
        const configuration = {
            settings,
            persistentIds: assets.map((a) => a.id),
        };
        // Render items
        const endpoint = this.bridge.getVersionEndpoint(designSystemId, versionId, "components/assets/download-list");
        // TODO:fix-sdk-eslint
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const data = await this.bridge.post(endpoint, configuration);
        // TODO:fix-sdk-eslint
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const items = data.result.items;
        // Create rendered items index
        const renderedItemsMap = new Map();
        for (const renderedItem of items) {
            renderedItemsMap.set(renderedItem.assetId, renderedItem);
        }
        if (Array.from(renderedItemsMap.entries()).length !== assets.length) {
            throw new Error("Number of rendered assets doesn't align with number of requested assets");
        }
        const assetsMap = new Map();
        for (const asset of assets) {
            assetsMap.set(asset.id, asset);
        }
        const resultingAssets = [];
        // For duplicates
        const names = new Map();
        for (const asset of assets) {
            const item = renderedItemsMap.get(asset.id);
            let renderedGroup;
            for (const group of groups) {
                if (group.assetIds.includes(asset.id)) {
                    renderedGroup = group;
                    break;
                }
            }
            // @ts-expect-error TS(2454): Variable 'renderedGroup' is used before being assi... Remove this comment to see the full error message
            const assetPath = this.assetPath(asset, renderedGroup, groups);
            if (!names.get(assetPath)) {
                names.set(assetPath, 0);
            }
            // @ts-expect-error TS(2454): Variable 'renderedGroup' is used before being assi... Remove this comment to see the full error message
            if (!renderedGroup) {
                throw new Error(`Each asset must be assigned to some group`);
            }
            const renderedAsset = new RenderedAsset(
            // @ts-expect-error TS(2345): Argument of type 'RenderedAssetModel | undefined' ... Remove this comment to see the full error message
            item, asset, renderedGroup, names.get(assetPath));
            // Increase number of duplicates
            // @ts-expect-error TS(2532): Object is possibly 'undefined'.
            names.set(assetPath, names.get(assetPath) + 1);
            // Store
            resultingAssets.push(renderedAsset);
        }
        return resultingAssets;
    }
    assetPath(asset, parent, allGroups) {
        const segments = [asset.name];
        let possibleParent = parent;
        while (possibleParent) {
            segments.push(possibleParent.name);
            const parentId = possibleParent.parentGroupId;
            if (!parentId) {
                break;
            }
            // @ts-expect-error TS(2322): Type 'AssetGroup | undefined' is not assignable to... Remove this comment to see the full error message
            possibleParent = allGroups.find((g) => g.persistentId === parentId);
        }
        return segments.reverse().join("/");
    }
}
